import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api';
import { appointmentEndpoints } from '@/lib/api/endpoints';
import { jobKeys } from '@/lib/queryKeys';
import type { UpdateInternalNotesDto } from '@/types/jobAppointment';

interface Vars extends UpdateInternalNotesDto {
  appointmentId: string;
}

/**
 * PATCH /appointments/:id/notes — persist internal staff-only notes.
 */
export function useUpdateInternalNotes(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<unknown, Vars>({
    mutationFn: ({ appointmentId, ...body }) =>
      apiPatch(operationsClient, appointmentEndpoints.notes(appointmentId), body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: jobKeys.appointments(jobId) });
      toast.success('Internal notes saved');
    },
  });
}
